import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Accounts } from '@styles/icons/accounts.svg';
import React from 'react';

export const AccountsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Accounts} viewBox={'0 0 18 22'} />
);

export default AccountsIcon;
